import { ApolloLink, Observable } from "@apollo/client";

let activeGqlRequests = 0;
let slowGqlTimer: any = null;

const slowResponseLink = new ApolloLink((operation, forward) => {
  activeGqlRequests++;

  // Start timer only for the first request
  if (activeGqlRequests === 1) {
    slowGqlTimer = setTimeout(() => {
      if (activeGqlRequests > 0) {
        window.dispatchEvent(new Event("slow-response-start"));
      }
    }, 60000);
  }

  // Wrap Observable to handle success + error
  return new Observable((observer) => {
    const subscription = forward(operation).subscribe({
      next: (result) => {
        observer.next(result);
      },
      error: (error) => {
        activeGqlRequests--;

        if (activeGqlRequests === 0) {
          clearTimeout(slowGqlTimer);
        }

        observer.error(error);
      },
      complete: () => {
        activeGqlRequests--;

        if (activeGqlRequests === 0) {
          clearTimeout(slowGqlTimer);
        }

        observer.complete();
      },
    });

    // Cleanup
    return () => {
      subscription.unsubscribe();
    };
  });
});

export default slowResponseLink;